module.exports = __webpack_public_path__ + "static/media/logoFormatics-light.28fbf03a.png";